export const USER_ATTRIBUTES_LOAD_REQUEST = 'USER_ATTRIBUTES_LOAD_REQUEST';
export const USER_ATTRIBUTES_LOAD_SUCCESS = 'USER_ATTRIBUTES_LOAD_SUCCESS';
export const USER_ATTRIBUTES_LOAD_FAILURE = 'USER_ATTRIBUTES_LOAD_FAILURE';
